import i18n from '@/utils/i18n';
import React from 'react';
import { ActionSheet } from '@/components/action-sheet';

export interface Props {
  onCancel: () => void;
  onConfirm: () => void;
  restaurantName: string;
}

export const RemoveProspectConfirmationActionSheet: React.FC<Props> = ({
  onConfirm,
  onCancel,
  restaurantName,
}) => {
  return (
    <ActionSheet
      actions={[i18n.t('cancel'), i18n.t('remove_prospect.button')]}
      dangerIndices={[1]}
      isVisible
      message={i18n.t('remove_prospect.message', {
        prospectName: restaurantName,
      })}
      onAction={(action) => {
        if (action === i18n.t('cancel')) {
          onCancel();
        }
        if (action === i18n.t('remove_prospect.button')) {
          onConfirm();
        }
      }}
      onClose={onCancel}
      title={i18n.t('remove_prospect.title', {
        prospectName: restaurantName,
      })}
    />
  );
};
